import React from 'react';
import { ReportType, reportTypes } from '../types/ReportTypes';
import { Button } from '@mui/material';

interface RapportChoseProps {
  onSelectReportType: (reportType: ReportType) => void;
  onBack: () => void;
}

const RapportChose: React.FC<RapportChoseProps> = ({ onSelectReportType, onBack }) => {
  return (
    <div className="bg-gray-100 w-full flex flex-col relative border-round-md" 
         style={{ 
           height: '80vh',
           boxShadow: '-8px 18px 21px -9px rgba(0,0,0,0.61)',
           WebkitBoxShadow: '-8px 18px 21px -9px rgba(0,0,0,0.61)'
         }}>
      
      {/* Header */}
      <div className="flex flex-row items-center w-full h-16 text-3xl bg-blue-600">
        <div
          onClick={onBack}
          className="absolute cursor-pointer px-3 py-2"
          style={{ left: '2%' }}
        >
          <i className="fas fa-solid fa-caret-left hover:text-red-400 text-4xl text-white"></i>
        </div>
        <div className="w-full text-center">
          <div className="pl-3 text-white text-xl font-semibold">Rapports</div>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col w-full">
        <div className="bg-gray-300 p-2">
          <div className="text-xl font-semibold">
            Sélectionner un type de rapport
          </div>
        </div>
        
        {/* Report Types List */}
        <div className="flex-1 overflow-auto">
          {reportTypes.map((reportType, index) => (
            <div
              key={index}
              onClick={() => onSelectReportType(reportType)}
              className="flex flex-row justify-between items-center bg-white hover:bg-gray-300 p-4 border-b-2 border-gray-300 cursor-pointer transition-colors"
            >
              <div className="flex items-center">
                <i className={`fas ${reportType.icon} text-2xl text-blue-600 mr-4`}></i>
                <div>
                  <div className="text-xl font-semibold">{reportType.title}</div>
                  <div className="text-gray-600">{reportType.description}</div>
                </div>
              </div>
              <i className="fas fa-chevron-right text-gray-400"></i>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RapportChose;
